import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
  const [loggedInToken, setLoggedInToken] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [companyName_findjob, setCompanyName] = useState(null);
  const [locationNames, setLocationNames] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ 初期読み込み（localStorage → Contextへ）
  useEffect(() => {
    const savedToken = localStorage.getItem("loggedInToken");
    const savedUserName = localStorage.getItem("userName");
    const savedRole = localStorage.getItem("userRole");
    const savedCompany = localStorage.getItem("companyName_findjob");
    const savedLocationNames = localStorage.getItem("locationNames");

    if (savedToken) {
      setLoggedInToken(savedToken);
      setIsAuthenticated(true);
      if (savedUserName) setUserName(savedUserName);
      if (savedRole) setUserRole(Number(savedRole));
      if (savedCompany) setCompanyName(savedCompany);
      if (savedLocationNames) {
        try {
          setLocationNames(JSON.parse(savedLocationNames));
        } catch (e) {
          setLocationNames(savedLocationNames);
        }
      }
    }

    setIsLoading(false);
  }, []);

  // ✅ loggedInTokenが変更されたらisAuthenticatedを更新
  useEffect(() => {
    setIsAuthenticated(!!loggedInToken);
  }, [loggedInToken]);

  // ✅ ログインが必要なページにリダイレクト
  useEffect(() => {
    const allowWithoutToken = ["/nameinput", "/auto-login", "/useraccess"];
    const requiresToken = !allowWithoutToken.includes(location.pathname);

    if (!isLoading && requiresToken && !loggedInToken) {
      //console.log("TokenProvider: No token found. Redirecting to /useraccess");
      navigate("/useraccess");
    }
  }, [isLoading, loggedInToken, location.pathname, navigate]);

  return (
    <TokenContext.Provider
      value={{
        loggedInToken,
        setLoggedInToken,
        loggedInUser,
        setLoggedInUser,
        userName,
        setUserName,
        userRole,
        setUserRole,
        companyName_findjob,
        setCompanyName,
        locationNames,
        setLocationNames,
        isAuthenticated,
        isLoading,
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};

export const useToken = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error("useToken must be used within a TokenProvider");
  }
  return context;
};
